export default __webpack_public_path__ + "images/0x888ef71766ca594ded1f0fa3ae64ed2941740a20.png";